import styled from 'styled-components';

export const Wrapper = styled.div`
    margin-bottom: 12px;
`;

export const Title = styled.div`
    font-weight: bold;
    margin-bottom: 8px;
`;

export const Item = styled.div`
    .udesk-qa-ui-tag {
        margin-bottom: 8px;
    }
`;

export const Empty = styled.div`
    color: #999;
    font-size: 12px;
`;
